import { Action } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import * as Objects from '@core/objects';
import { AddVersion, AddVersionErrors } from "@core/models/add-version";


export enum AddVersionActionType {
    // InitAddVersion = "[AddVersion] Initialize new version data",
    // UpdateAddVersion = "[AddVersion] Update new version data",
    Clear = "[AddVersion] Clear data",
    SetErrors = "[AddVersion] Set error flags",
    ClearErrors = "[AddVersion] Clear error flags",
    SubmitAddVersion = "[AddVersion] Submit new version",           // New action
    SubmitAddVersionSuccess = "[AddVersion] Submit new version success", // New action
    SubmitAddVersionFailure = "[AddVersion] Submit new version failure"  // New action
}

// export class InitAddVersion implements Action {
//     readonly type = AddVersionActionType.InitAddVersion;
//     constructor(public workflowId: number, public versionId: number | null) {}
// }

// export class UpdateAddVersion implements Action {
//     readonly type = AddVersionActionType.UpdateAddVersion;
//     constructor(public property: Partial<AddVersion>) {}
// }

export class Clear implements Action {
    readonly type = AddVersionActionType.Clear;
    constructor() {}
}

export class SetErrors implements Action {
    readonly type = AddVersionActionType.SetErrors;
    constructor(public errors: Partial<AddVersionErrors>) {}
}

export class ClearErrors implements Action {
    readonly type = AddVersionActionType.ClearErrors;
    constructor() {}
}

export class SubmitAddVersion implements Action {
    readonly type = AddVersionActionType.SubmitAddVersion;
    constructor(public projectId: number, public payload: AddVersion) {}
}

export class SubmitAddVersionSuccess implements Action {
    readonly type = AddVersionActionType.SubmitAddVersionSuccess;
    constructor( public version: Objects.Version) {}
}

export class SubmitAddVersionFailure implements Action {
    readonly type = AddVersionActionType.SubmitAddVersionFailure;
    constructor(public error: HttpErrorResponse) {}
}

export type AddVersionActions =
        // | InitAddVersion
        // | UpdateAddVersion
        | Clear
        | SetErrors
        | ClearErrors
        | SubmitAddVersion
        | SubmitAddVersionSuccess
        | SubmitAddVersionFailure;